enum Sections {
  ABOUT = 'ABOUT',
  SERVICE = 'SERVICE',
}

export default Sections;
